module.exports = {"web_title":"我的网站"}


//////////////////
// WEBPACK FOOTER
// ./website/language/lang/zh.json
// module id = 5phe
// module chunks = 50